<div #contentContainer [style.width]="'100%'" [style.height]="'100%'">
  <ng-container *ngIf="shouldShowPreviewInsteadOfImage$ | async; else normalImage">
    <app-pdf-hidden-page [static]="true"></app-pdf-hidden-page>
  </ng-container>
</div>

<ng-template #normalImage>
  <app-user-intersection-wrapper
    *ngIf="state.url; else uploadingIndicator"
    (intersectionChange)="handleIntersectionChange($event)"
    [disabled]="static"
  >
    <img
      #image
      *ngIf="state.url && (imageLoadingState$ | async) !== ImageLoadingState.DidNotAttemptToLoad"
      [src]="state.url"
      class="item-img"
      draggable="false"
      alt="loading"
      (load)="handleImageLoaded()"
      (error)="handleImageLoadingFailure()"
    />

    <!--  We need to have an explicit width and height to help the intersection observer detect the intersection: [SPAC-10760][SPAC-10262] -->
    <div
      *ngIf="!this.static"
      [style.width.px]="state.width * state.scaleX"
      [style.height.px]="state.height * state.scaleY"
    >
      <ng-container
        *ngIf="(imageLoadingState$ | async) === ImageLoadingState.FailedToLoad"
        [ngTemplateOutlet]="failedToLoadContainer"
      >
      </ng-container>

      <!--      No need to hide the loading indicator currently as this component will be destroyed once we render the image in fabric-->
      <!--      This makes the image only appear in fabric canvas once it loads-->
      <ng-container *ngIf="showLoadingIndicator$ | async" [ngTemplateOutlet]="loadingIndicator">
      </ng-container>
    </div>
  </app-user-intersection-wrapper>
</ng-template>

<ng-template #loadingIndicator>
  <app-loading
    *ngIf="showLoadingIndicatorOnLoading && !isTouchDevice"
    class="absolute-loading"
    [loading]="true"
    [layoutType]="customLoadingLayout ? LoadingLayoutType.PDF : LoadingLayoutType.IMAGE_LOADING"
    [smallContainerControlEnabled]="true"
    [smallContainer]="smallContainer$ | async"
  ></app-loading>
</ng-template>

<ng-template #failedToLoadContainer>
  <div class="loading-failed-container">
    <span [hidden]="smallContainer$ | async">
      {{
        'It appears your network connection might be unstable. Please wait a few moments or try another network.'
          | translate
      }}
    </span>
    <app-pencil-button
      #reloadButton
      class="pencil-button primary large"
      (clickEvent)="handleReloadImage()"
    >
      <app-pencil-icon name="refresh" type="mat-icon" height="18" width="18"></app-pencil-icon>
      <span *ngIf="(smallContainer$ | async) === false">{{ 'Reload' | translate }}</span>
    </app-pencil-button>
  </div>
</ng-template>

<ng-template #uploadingIndicator>
  <app-resource-loading-item-canvas
    *ngIf="showUploadIndicator$ | async"
    [uploadId]="state.uid"
    [width]="state.width * state.scaleX"
    [height]="state.height * state.scaleY"
    [itemType]="ResourceItemModel.IMAGE"
  ></app-resource-loading-item-canvas>
</ng-template>
